import { render, staticRenderFns } from "./PCApplyCooperation.vue?vue&type=template&id=389ea95e&scoped=true&"
import script from "./PCApplyCooperation.vue?vue&type=script&lang=js&"
export * from "./PCApplyCooperation.vue?vue&type=script&lang=js&"
import style0 from "./PCApplyCooperation.vue?vue&type=style&index=0&id=389ea95e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ea95e",
  null
  
)

export default component.exports